import { Inject, Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { BackendError, BackendErrorResponse, RestErrorEventCategory } from '../../../domain/error.domain';
import { SYSTEM_STATUS_CONFIGURATION } from '../../system-status/system-status.service';
import { SystemStatusConfiguration } from '../../system-status/system-status.domain';
import { RestErrorHandler } from '../rest-error-handler.service';

@Injectable({
  providedIn: 'root'
}
)
export class RestApplicationErrorHandlerService implements RestErrorHandler {

  readonly onCriticalApplicationError: Subject<BackendError>;

  private readonly criticalErrorCode: string;

  constructor(@Inject(SYSTEM_STATUS_CONFIGURATION)
  private configuration: SystemStatusConfiguration) {
    this.onCriticalApplicationError = new Subject<BackendError>();

    this.criticalErrorCode = this.configuration.systemDownErrorCode;
  }

  handleErrors(errors: Array<BackendError>): BackendErrorResponse {
    let result: BackendErrorResponse;
    for (const error of errors) {
      if (this.isCriticalError(error)) {
        result = { ...error, category: RestErrorEventCategory.SYSTEM_DOWN };
        this.onCriticalApplicationError.next(result);
        break;
      }
    }
    return result;
  }

  private isCriticalError(error: BackendError): boolean {
    return error.code === this.criticalErrorCode;
  }

}
